import React from "react";
import { motion } from "framer-motion";
import { Star, Users, Rocket } from "lucide-react";
import mockupImage from "../../../images/webtechhome/websiteredesing.png";

const stats = [
  { icon: Star, value: "10+", label: "Years Experience" },
  { icon: Users, value: "200+", label: "Happy Clients" },
  { icon: Rocket, value: "500+", label: "Projects Completed" },
];

const WredIntroSection: React.FC = () => (
  <section className="wred-intro-section" aria-labelledby="wred-intro-title">
    <div className="wredesign-container">
      <div className="wred-intro-section__grid">
        <motion.div
          className="wred-intro-section__content"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
        >
          <span className="wred-intro-section__eyebrow">Best in Bangalore</span>
          <h2 id="wred-intro-title">
            WebTech Software Solutions is the best website redesigning company in{" "}
            <span>Bangalore</span>
          </h2>
          <p>
            Just like all the other aspects of maintaining a successful business, your website
            too requires redesigning every once in a while. There are many things that change
            with time and the same website that you launched five years ago might now have
            turned obsolete.
          </p>
          <p>
            Known as one of the best professional services in Bangalore, we understand the need
            of revamping your website from time to time and providing necessary upgrades. This
            will allow you to stay afloat in this highly competitive era and hold your own
            against your competition.
          </p>
        </motion.div>

        <motion.div
          className="wred-intro-section__visual"
          initial={{ opacity: 0, x: 24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.65, delay: 0.1 }}
          aria-hidden="true"
        >
          <div className="wred-before-after">
            <div className="wred-before-after__card wred-before-after__card--before">
              <span>Before</span>
              <div className="wred-before-after__wireframe">
                <div />
                <div />
                <div />
                <div className="wred-before-after__wireframe-row">
                  <div />
                  <div />
                  <div />
                </div>
              </div>
            </div>
            <div className="wred-before-after__arrow" aria-hidden="true">
              <svg width="40" height="16" viewBox="0 0 40 16" fill="none">
                <path
                  d="M0 8h32M32 8l-6-6M32 8l-6 6"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="wred-before-after__card wred-before-after__card--after">
              <span>After</span>
              <div className="wred-before-after__preview">
                <img src={mockupImage} alt="" loading="lazy" />
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      <motion.ul
        className="wred-intro-stats"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.55, delay: 0.15 }}
        aria-label="Company statistics"
      >
        {stats.map(({ icon: Icon, value, label }) => (
          <li key={label} className="wred-intro-stats__item">
            <span className="wred-intro-stats__icon" aria-hidden="true">
              <Icon size={22} strokeWidth={1.75} />
            </span>
            <span className="wred-intro-stats__text">
              <strong>{value}</strong> {label}
            </span>
          </li>
        ))}
      </motion.ul>
    </div>
  </section>
);

export default WredIntroSection;
